"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAttributesAsString = exports["default"] = void 0;
var _customisationModule = _interopRequireDefault(require("./customisation.module.scss"));
var _react = _interopRequireDefault(require("react"));
var _icon = _interopRequireDefault(require("../../icon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getAttributesAsString = exports.getAttributesAsString = function getAttributesAsString(props) {
  var type = "";
  var position = "";
  var width = "";
  if (props.type) {
    type = "".concat(props.type, ", ");
  }
  if (props.position) {
    position = "".concat(props.position, ", ");
  }
  if (props.width) {
    width = "".concat(props.width, "cm");
  }
  return "".concat(type).concat(position).concat(width).trim().replace(/(,$)/g, "");
};
var ViewBox = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: ref,
    className: "".concat(_customisationModule["default"].viewBox, " ").concat(props.extendedDetails && _customisationModule["default"].extended),
    "data-testid": "populated-customisation-card"
  }, props.canDelete && /*#__PURE__*/_react["default"].createElement("div", {
    className: _customisationModule["default"].deleteIcon,
    "data-testid": "customisation-card-delete",
    onClick: function onClick(event) {
      return props.onDelete(event);
    }
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    type: "Bin"
  })), props.canRemove && /*#__PURE__*/_react["default"].createElement("div", {
    className: _customisationModule["default"].close,
    "data-testid": "customisation-card-close",
    onClick: function onClick() {
      return props.onClose();
    }
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    type: "Close"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _customisationModule["default"].name,
    title: props.name,
    "data-testid": "customisation-card-name"
  }, props.name), /*#__PURE__*/_react["default"].createElement("div", {
    className: _customisationModule["default"].preview,
    "data-testid": "customisation-card-preview",
    onClick: function onClick() {
      return props.canAdd && props.onAdd();
    }
  }, props.children), /*#__PURE__*/_react["default"].createElement("div", {
    className: _customisationModule["default"].details,
    "data-testid": "customisation-card-details"
  }, getAttributesAsString(props), props.extendedDetails && /*#__PURE__*/_react["default"].createElement("div", {
    className: _customisationModule["default"].extended,
    "data-testid": "customisation-card-details-extended"
  }, props.transparent && /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "customisation-card-background"
  }, "Remove background"), /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "customisation-card-paid-status"
  }, props.paidStatus ? "Purchased" : "Not purchased"), props.redrawService && /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "customisation-card-redraw"
  }, "Redraw selected"))), /*#__PURE__*/_react["default"].createElement("div", {
    className: _customisationModule["default"].buttonTags
  }, props.canEdit && /*#__PURE__*/_react["default"].createElement("div", {
    className: _customisationModule["default"].tag,
    "data-testid": "customisation-card-edit",
    onClick: function onClick() {
      return props.onEdit();
    }
  }, "Edit"), props.canAdd && /*#__PURE__*/_react["default"].createElement("div", {
    className: _customisationModule["default"].tag,
    "data-testid": "customisation-card-add",
    onClick: function onClick() {
      return props.onAdd();
    }
  }, "Add")));
});
var _default = exports["default"] = ViewBox;